import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CemeterySelectedService {
  private selectedCemeteries: Subject<Array<string>> = new BehaviorSubject<
    Array<string>
  >([]);

  constructor() {}

  get selectedCemeteries$() {
    return this.selectedCemeteries.asObservable();
  }

  setSelectedCemetrieis(data: Array<string>) {
    this.selectedCemeteries.next(data);
  }
}
